import React, { useState } from 'react';

const CurlImporter = ({ onImport }) => {
  const [curlCommand, setCurlCommand] = useState('');
  const [error, setError] = useState('');

  const parseCurl = (curl) => {
    try {
      setError('');

      // Extract URL  
      const urlMatch = curl.match(/curl\s+['"]?([^\s'"]+)['"]?/);
      if (!urlMatch) {
        throw new Error('Invalid cURL command: URL not found');
      }
      const url = urlMatch[1];

      // Extract method  
      const methodMatch = curl.match(/-X\s+(\w+)/i);
      const method = methodMatch ? methodMatch[1].toUpperCase() : 'GET';

      // Extract headers  
      const headerMatches = curl.matchAll(/-H\s+['"]([^'"]+)['"]/g);
      const headers = {};
      for (const match of headerMatches) {
        const [key, ...valueParts] = match[1].split(':');
        headers[key.trim()] = valueParts.join(':').trim();
      }

      // Extract body  
      const bodyMatch = curl.match(/--data(?:-raw)?\s+['"](.+)['"]/s);
      const body = bodyMatch ? bodyMatch[1] : '';

      onImport({ url, method, headers, body });
      setCurlCommand('');
    } catch (err) {
      setError(err.message);
    }
  };

  const placeholderText = `curl -X POST 'https://api.example.com/endpoint' -H 'Content-Type: application/json' --data '{"key":"value"}'`;

  return (
    <div>
      <h3 style={styles.title}>Import from cURL</h3>
      <p style={styles.description}>
        Paste your cURL command to automatically configure the request
      </p>

      {error && (
        <div className="error-message" style={{ marginBottom: '15px' }}>
          <span>⚠️</span>
          <span>{error}</span>
        </div>
      )}

      <div className="input-group">
        <textarea
          value={curlCommand}
          onChange={(e) => setCurlCommand(e.target.value)}
          placeholder={placeholderText}
          style={{ fontFamily: 'monospace', minHeight: '100px' }}
        />
      </div>

      <button
        type="button"
        className="btn btn-secondary"
        onClick={() => parseCurl(curlCommand)}
        disabled={!curlCommand.trim()}
      >
        Import cURL
      </button>
    </div>
  );
};

const styles = {
  title: {
    fontSize: '13px',
    fontWeight: '600',
    marginBottom: '12px',
    color: 'var(--text-primary)',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  description: {
    color: 'var(--text-secondary)',
    marginBottom: '16px',
    fontSize: '14px',
  },
};

export default CurlImporter;

